// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--1nBq8","link":"a10a3f92e9--link--2Aiso","reliable":"a10a3f92e9--reliable--2foNn","status":"a10a3f92e9--status--NCVlN"};